import { Component, OnInit, ViewChild } from '@angular/core';
import { OregonWellDataService } from '../../../services/oregon-well-data.service'
import { VoucherService } from '../../../services/voucher-service';
import { MatDialog } from '@angular/material/dialog';
import { VoucherApplication } from 'app/models/vouchers/voucher-application';
import { MatTableDataSource } from '@angular/material/table';
import { OregonWellAzueService } from 'app/services/azure-service';
import { ActivatedRoute } from '@angular/router';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';

@Component({
  selector: 'import-voucher-applications',
  templateUrl: './import-voucher-applications.html'
})
export class ImportVoucherApplicationsComponent implements OnInit {
  loading: boolean = false;
  loadingResponses: boolean = false;
  importing: boolean = false;
  showSuccess: boolean = false;
  authenticated: boolean = false;
  selectedVoucherType: string = '';
  isLinear: boolean = true;
  voucherResponses: VoucherApplication[] = [];
  displayedColumnsLubgwma: string[] = ['applicationSelected', 'wellAddress', 'wellCounty', 'wellLabelTagNumber', 'privateWell', 'applicantContactName', 'contactHomeAddress', 'contactMailingAddress', 'voucherIdentifier','applicationStatus'];
  displayedColumnsWildfire: string[] = ['applicationSelected', 'applicationType', 'wellAddress', 'wellCounty', 'wellLabelTagNumber', 'applicantContactName', 'wildfires'];
  dataSource = new MatTableDataSource<VoucherApplication>();
  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;
  
  selectedApplicationIndex: number = -1;

  constructor(public oregonWellService: OregonWellDataService, public voucherService: VoucherService,
    public dialog: MatDialog, public oregonWellAzueService: OregonWellAzueService, private route: ActivatedRoute) {

    const parameterType = String(this.route.snapshot.paramMap.get("type"));

    if (parameterType != null) {
      this.selectedVoucherType = parameterType;
    }
  }

  ngOnInit() {
    // ngOnInit
  }

  loadResponses() {
    this.loadingResponses = true;
    this.oregonWellAzueService.getVoucherImportApplications(this.selectedVoucherType).then(
      result => {
        this.voucherResponses = result;
        this.dataSource = new MatTableDataSource<VoucherApplication>(this.voucherResponses);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
        this.loadingResponses = false;
      },
      error => {
        this.loadingResponses = false;
      }
    );

  }

  setSelectedApplicationIndex(i: number) {
    this.selectedApplicationIndex = i;
  }

  import() {
    this.importing = true;
    if (this.selectedApplicationIndex >= 0) {
      this.voucherService.importResponse(this.voucherResponses[this.selectedApplicationIndex]).subscribe(
        result => {
          this.oregonWellAzueService.setEntityProcessed(this.selectedVoucherType, this.voucherResponses[this.selectedApplicationIndex].voucherResponseRowKey).then(
            result => {
              this.importing = false;
              this.showSuccess = true;
              this.selectedApplicationIndex = -1;
              this.loadResponses();
            }
          );
        },
        error => {
          this.importing = false;
        }
      );
    }
  }
}